// Form Builder Models and Interfaces

export interface Module {
  id: string;
  name: string;
  key: 'lead' | 'registration' | 'application';
}

export interface Field {
  id: string;
  field_name: string;
  label: string;
  data_type: 'string' | 'number' | 'boolean' | 'date' | 'enum' | 'text';
  module_id: string;
  module_name: string;
  is_required: boolean;
  is_system_field: boolean;
  options?: string[]; // For enum types
}

export interface UIType {
  key: string;
  label: string;
  compatibleDataTypes: string[];
}

export interface FormFieldConfig {
  id?: string;
  field_id: string;
  field: Field;
  ui_type: string;
  is_required: boolean;
  placeholder?: string;
  help_text?: string;
  default_value?: any;
  validation_rules?: any;
  order: number;
  row?: number; // Row position in form layout
  col?: number; // Column position within row
  row_cols?: number; // Number of columns in this row (only set on first field of row)
  options?: string[]; // For select dropdowns
  field_type?: 'static' | 'dynamic'; // static = predefined fields, dynamic = API fields
}

export interface DynamicForm {
  id?: string;
  form_name: string;
  module_id: string;
  module_name?: string;
  description?: string;
  is_published: boolean;
  public_token?: string;
  fields: FormFieldConfig[];
  created_at?: Date;
  updated_at?: Date;
  organization_id: string;
  campus_id?: string;
}

export interface FormValidationResult {
  isValid: boolean;
  errors: string[];
}

export const UI_TYPE_MAPPINGS: UIType[] = [
  { key: 'text', label: 'Text Input', compatibleDataTypes: ['string'] },
  { key: 'textarea', label: 'Text Area', compatibleDataTypes: ['string', 'text'] },
  { key: 'number', label: 'Number Input', compatibleDataTypes: ['number'] },
  { key: 'email', label: 'Email Input', compatibleDataTypes: ['string'] },
  { key: 'tel', label: 'Phone Input', compatibleDataTypes: ['string'] },
  { key: 'date', label: 'Date Picker', compatibleDataTypes: ['date'] },
  { key: 'checkbox', label: 'Checkbox', compatibleDataTypes: ['boolean'] },
  { key: 'select', label: 'Dropdown Select', compatibleDataTypes: ['enum', 'string'] },
  { key: 'radio', label: 'Radio Buttons', compatibleDataTypes: ['enum', 'string'] },
  { key: 'multiselect', label: 'Multi-Select', compatibleDataTypes: ['enum'] }
];

export const AVAILABLE_MODULES: Module[] = [
  { id: 'Leads', name: 'Leads', key: 'lead' },
  { id: 'Registration', name: 'Registration', key: 'registration' },
  { id: 'Application', name: 'Application', key: 'application' }
];
